import React from 'react';

import type { CardAction } from '../../config/NotificationTypes';
import { ActionType } from '../../enums';
import Buttons from '../Buttons/Buttons';
import DataList from '../DataList/DataList';

import { TXTCLI_Next, TXTCLI_Previous } from './PaginatedData.messages.json';

const i18nTags = {
  prev: { tag: TXTCLI_Previous, values: {} },
  next: { tag: TXTCLI_Next, values: {} }
};

interface Props {
  pageSize: number;
  dataSet: object[];
  columnKeys: string[];
}

class PaginatedData extends React.PureComponent<Props> {
  state = {
    idxTo: 0,
    idxFrom: 0,
    pageSize: 10,
    currentPage: 0,
    nextDisabled: true,
    prevDisabled: true
  };

  componentDidMount() {
    const { pageSize, dataSet } = this.props;
    const dataSize = dataSet.length;
    this.setState({
      pageSize,
      idxTo: pageSize,
      nextDisabled: dataSize && pageSize >= dataSize
    });
  }

  onClickPrev = () => {
    const { dataSet } = this.props;
    const { currentPage, pageSize } = this.state;
    const nextIdx = (currentPage - 1) * pageSize;
    const idxTo = nextIdx + pageSize;

    if (nextIdx >= 0) {
      this.setState({
        idxTo,
        idxFrom: nextIdx,
        currentPage: currentPage - 1,
        prevDisabled: nextIdx === 0,
        nextDisabled: idxTo === dataSet.length
      });
    }
    return {};
  };

  onClickNext = () => {
    let idxTo;
    const { dataSet } = this.props;
    const { currentPage, pageSize } = this.state;
    const nextIdx = (currentPage + 1) * pageSize;

    if (nextIdx + pageSize > dataSet.length) {
      idxTo = dataSet.length;
    } else {
      idxTo = nextIdx + pageSize;
    }

    if (nextIdx < dataSet.length) {
      this.setState({
        idxTo,
        idxFrom: nextIdx,
        currentPage: currentPage + 1,
        prevDisabled: nextIdx === 0,
        nextDisabled: idxTo === dataSet.length
      });
    }
    return {};
  };

  render() {
    const { columnKeys, dataSet } = this.props;
    const { idxFrom, idxTo, prevDisabled, nextDisabled } = this.state;

    const currentIdxTo = idxTo >= dataSet.length ? dataSet.length : idxTo;
    const displayData = dataSet.slice(idxFrom, currentIdxTo);

    const actionButtons: CardAction[] = [];

    if (!nextDisabled) {
      actionButtons.push({
        actionType: ActionType.Primary,
        actionLabel: i18nTags.next,
        actionFunction: this.onClickNext
      });
    }

    if (!prevDisabled) {
      actionButtons.push({
        actionType: ActionType.Secondary,
        actionLabel: i18nTags.prev,
        actionFunction: this.onClickPrev
      });
    }

    return (
      <>
        <DataList dataList={displayData} columnKeys={columnKeys} />
        {!(prevDisabled && nextDisabled) && <Buttons actionList={actionButtons} />}
      </>
    );
  }
}

export default PaginatedData;
